import { render, staticRenderFns } from "./updatePosition.vue?vue&type=template&id=76b97e0d&"
import script from "./updatePosition.vue?vue&type=script&lang=js&"
export * from "./updatePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports